// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__3-u4b","margin":"input_margin__29VlO"};